<template>
	<div data-tour-scope="setting-seo">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.seo') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>

						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni servizio diventa una card, il form di configurazione resta dentro la card -->
								<tbody v-if="mobileCards" class="seo-cards">
									<!-- Analisi SEO: solo attivazione (il servizio resta 'yoast' nel db) -->
									<tr>
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-icon color="primary" class="mr-2">mdi-chart-box-outline</v-icon>
														Analisi SEO
													</span>
													<div class="seo-small">{{ descrizioneAnalisi }}</div>
												</template>
												<template v-slot:actions>
													<v-switch v-if="yoast" v-model="yoast.active" @change="saveSetting(0)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 1 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:data-tour="s.indice === 1 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<!-- Google Translate: video per le API key -->
													<div v-if="s.key === 'googletranslate'" class="seo-video">
														<div class="seo-video-caption">
															<v-avatar size="20px" tile class="mr-2"><img :src="require('@/assets/images/video/youtube-3.svg')" alt="YouTube" /></v-avatar>
															Video per ottenere le API Key da inserire in Az Seller
														</div>
														<youtube :video-id="videtranslate" player-width="100%"></youtube>
													</div>
													<!-- Google Merchant: credenziali JSON -->
													<div v-if="s.key === 'googlemerchant'" class="mb-3">
														<v-file-input
															v-model="file"
															label="File JSON con le credenziali di Google"
															accept=".json"
															show-size
															dense
															outlined
															hide-details
															background-color="white"
															@change="handleFileUpload"
														></v-file-input>
														<a v-if="googlemerchant.setting.apikey" :href="googlemerchant.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														<div class="seo-small mt-2">Per le analisi nella modifica prodotto (rendimento, prezzo dei concorrenti, più venduti) dai al service account anche il ruolo <b>Rendimento e approfondimenti</b> in Merchant Center e abilita la <b>Merchant API</b> nella console Google Cloud.</div>
													</div>
													<!-- Google Search Console: istruzioni e credenziali JSON del service account -->
													<template v-if="s.key === 'googlesearchconsole'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
															Serve per vedere nella modifica prodotto come si posiziona la pagina su Google (clic, impressioni, posizione della parola chiave).
															<ol class="mt-2 mb-0">
																<li>Nella console Google Cloud abilita <b>Google Search Console API</b> e crea un service account con una chiave JSON.</li>
																<li>In Search Console apri <b>Impostazioni &gt; Utenti e autorizzazioni</b> e aggiungi l'email del service account (basta "Limitato").</li>
																<li>Carica qui il file JSON e scrivi la proprietà: <b>sc-domain:tuosito.it</b> per una proprietà dominio, <b>https://www.tuosito.it/</b> per una con prefisso URL.</li>
															</ol>
														</v-alert>
														<div class="mb-3">
															<v-file-input
																v-model="fileSearchConsole"
																label="File JSON del service account"
																accept=".json"
																show-size
																dense
																outlined
																hide-details
																background-color="white"
																@change="f => handleFileUpload(f, 'googlesearchconsole')"
															></v-file-input>
															<a v-if="googlesearchconsole.setting.apikey" :href="googlesearchconsole.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														</div>
													</template>
													<!-- Google Ads - Keyword Planner: idee per la parola chiave, in alternativa a DataForSEO; niente developer token, l'accesso e' del progetto Google Cloud -->
													<template v-if="s.key === 'googleads'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
															Fonte gratuita per <strong>Idee parole chiave</strong> nel pannello Analisi SEO, in alternativa a DataForSEO (se ne attiva uno solo). Serve un account Google Ads tuo:
															<ol class="mt-2 mb-0">
																<li>Nella console Google Cloud abilita <b>Google Ads API</b> e crea un service account con una chiave JSON.</li>
																<li>Dalla <b>Panoramica</b> della Google Ads API, nello stesso progetto, chiedi l'<b>accesso Basic</b> (serve la verifica del brand): con l'accesso di test o Explorer Keyword Planner non funziona. Il developer token non serve più.</li>
																<li>In Google Ads apri <b>Amministrazione &gt; Accesso e sicurezza</b> e aggiungi l'email del service account (qualsiasi livello tranne "Solo email").</li>
																<li>Carica qui il file JSON e scrivi l'ID cliente (10 cifre); l'ID dell'account manager solo se entri da lì.</li>
															</ol>
														</v-alert>
														<div class="mb-3">
															<v-file-input
																v-model="fileGoogleAds"
																label="File JSON del service account"
																accept=".json"
																show-size
																dense
																outlined
																hide-details
																background-color="white"
																@change="f => handleFileUpload(f, 'googleads')"
															></v-file-input>
															<a v-if="googleads.setting.apikey" :href="googleads.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														</div>
													</template>
													<!-- DataForSEO: idee per la parola chiave nell'Analisi SEO; la password non torna mai dal server -->
													<template v-if="s.key === 'dataforseo'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
														Nel pannello Analisi SEO di prodotti, categorie, marche, pagine e articoli compare <strong>Idee parole chiave</strong>: alternative alla parola chiave con volume di ricerca mensile, andamento, difficoltà e intento. Ogni nuova ricerca costa circa 1 centesimo sul saldo DataForSEO; le ricerche già fatte restano salvate per 30 giorni. Login e password sono quelli API di
														<a href="https://app.dataforseo.com/api-access" target="_blank" rel="noopener">app.dataforseo.com/api-access</a>, non quelli di accesso al sito.
														</v-alert>
														<div class="seo-small mb-2">
															Password API:
															<v-chip x-small label :color="dataforseo.setting.hasPassword ? 'success' : 'grey lighten-2'" class="ml-1">{{ dataforseo.setting.hasPassword ? 'Impostata' : 'Assente' }}</v-chip>
															<span v-if="dataforseo.setting.hasPassword" class="ml-1">lasciala vuota per non cambiarla</span>
														</div>
													</template>
													<!-- Google Trends: API in alpha, accesso su richiesta -->
													<template v-if="s.key === 'googletrends'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
															Mostra nella modifica prodotto come cambia negli ultimi 5 anni l'interesse su Google per la parola chiave principale (andamento, variazione annua, mesi di picco).
															<div class="mt-2">
																La <b>Google Trends API</b> è in alpha: l'accesso si ottiene su richiesta a Google. Finché non è attivo, il box nella scheda prodotto mostra un avviso.
															</div>
														</v-alert>
														<div class="mb-3">
															<v-file-input
																v-model="fileTrends"
																label="File JSON delle credenziali (quando l'accesso sarà attivo)"
																accept=".json"
																show-size
																dense
																outlined
																hide-details
																background-color="white"
																@change="f => handleFileUpload(f, 'googletrends')"
															></v-file-input>
															<a v-if="googletrends.setting.apikey" :href="googletrends.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														</div>
													</template>
													<!-- Facebook Marketplace: url dei feed da inserire nel catalogo -->
													<v-alert v-if="s.key === 'facebookmarketplace'" outlined text dense type="info" class="text-body-2 seo-url mb-3">
														Dopo aver cliccato su Salva inserire i seguenti url su https://www.facebook.com/products/catalogs
														<div v-for="feed in facebookMarketplaceFeedUrls" :key="feed.lang" class="mt-2">
															<b>{{ feed.label }}</b> {{ feed.url }}
														</div>
														<p class="mt-2 mb-0">
															Nella piattaforma https://business.facebook.com/commerce_manager bisogna inserire i cataloghi nelle varie lingue, creare lo shop e associare le lingue ai vari paesi.
														</p>
													</v-alert>
													<template v-slot:dopo>
														<esclusioni-feed
															v-if="s.feed"
															:modello="modello(s)"
															:categorie="categoryGoogleMerchant"
															:brands="brands"
															:listcategories="listcategories"
															:listitems-i-t="listitemsIT"
															:search-item-i-t.sync="searchItemIT"
														/>
													</template>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"
															><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn
														>
														<template v-if="s.key === 'googlemerchant'">
															<v-btn small outlined color="primary" @click="sendItem(2)"><v-icon left small>mdi-upload</v-icon>Carica prodotti</v-btn>
															<v-btn small outlined color="primary" @click="sendShipping(2)"><v-icon left small>mdi-truck-outline</v-icon>Carica spese di spedizione</v-btn>
															<v-btn small outlined color="error" @click="confermaElimina = true"><v-icon left small>mdi-delete-outline</v-icon>Elimina prodotti</v-btn>
															<v-spacer></v-spacer>
														</template>
														<v-spacer v-if="s.connessione && s.key !== 'googlemerchant'"></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<!-- Analisi SEO: solo attivazione (il servizio resta 'yoast' nel db) -->
									<tr>
										<td></td>
										<td>
											<div class="d-flex align-center">
												<v-avatar size="32px" tile>
													<v-icon color="primary">mdi-chart-box-outline</v-icon>
												</v-avatar>
												<div class="ml-1">
													Analisi SEO
													<div class="seo-small">{{ descrizioneAnalisi }}</div>
												</div>
											</div>
										</td>
										<td>
											<v-switch v-if="yoast" v-model="yoast.active" @change="saveSetting(0)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
									</tr>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 1 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" :intestazione="true" :data-tour="s.indice === 1 ? 'settings' : null" @save="saveSetting(s.indice)">
													<!-- Google Translate: video per le API key -->
													<div v-if="s.key === 'googletranslate'" class="seo-video">
														<div class="seo-video-caption">
															<v-avatar size="20px" tile class="mr-2"><img :src="require('@/assets/images/video/youtube-3.svg')" alt="YouTube" /></v-avatar>
															Video per ottenere le API Key da inserire in Az Seller
														</div>
														<youtube :video-id="videtranslate" player-width="100%"></youtube>
													</div>
													<!-- Google Merchant: credenziali JSON -->
													<div v-if="s.key === 'googlemerchant'" class="mb-3">
														<v-file-input
															v-model="file"
															label="File JSON con le credenziali di Google"
															accept=".json"
															show-size
															dense
															outlined
															hide-details
															background-color="white"
															@change="handleFileUpload"
														></v-file-input>
														<a v-if="googlemerchant.setting.apikey" :href="googlemerchant.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														<div class="seo-small mt-2">Per le analisi nella modifica prodotto (rendimento, prezzo dei concorrenti, più venduti) dai al service account anche il ruolo <b>Rendimento e approfondimenti</b> in Merchant Center e abilita la <b>Merchant API</b> nella console Google Cloud.</div>
													</div>
													<!-- Google Search Console: istruzioni e credenziali JSON del service account -->
													<template v-if="s.key === 'googlesearchconsole'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
															Serve per vedere nella modifica prodotto come si posiziona la pagina su Google (clic, impressioni, posizione della parola chiave).
															<ol class="mt-2 mb-0">
																<li>Nella console Google Cloud abilita <b>Google Search Console API</b> e crea un service account con una chiave JSON.</li>
																<li>In Search Console apri <b>Impostazioni &gt; Utenti e autorizzazioni</b> e aggiungi l'email del service account (basta "Limitato").</li>
																<li>Carica qui il file JSON e scrivi la proprietà: <b>sc-domain:tuosito.it</b> per una proprietà dominio, <b>https://www.tuosito.it/</b> per una con prefisso URL.</li>
															</ol>
														</v-alert>
														<div class="mb-3">
															<v-file-input
																v-model="fileSearchConsole"
																label="File JSON del service account"
																accept=".json"
																show-size
																dense
																outlined
																hide-details
																background-color="white"
																@change="f => handleFileUpload(f, 'googlesearchconsole')"
															></v-file-input>
															<a v-if="googlesearchconsole.setting.apikey" :href="googlesearchconsole.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														</div>
													</template>
													<!-- Google Ads - Keyword Planner: idee per la parola chiave, in alternativa a DataForSEO; niente developer token, l'accesso e' del progetto Google Cloud -->
													<template v-if="s.key === 'googleads'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
															Fonte gratuita per <strong>Idee parole chiave</strong> nel pannello Analisi SEO, in alternativa a DataForSEO (se ne attiva uno solo). Serve un account Google Ads tuo:
															<ol class="mt-2 mb-0">
																<li>Nella console Google Cloud abilita <b>Google Ads API</b> e crea un service account con una chiave JSON.</li>
																<li>Dalla <b>Panoramica</b> della Google Ads API, nello stesso progetto, chiedi l'<b>accesso Basic</b> (serve la verifica del brand): con l'accesso di test o Explorer Keyword Planner non funziona. Il developer token non serve più.</li>
																<li>In Google Ads apri <b>Amministrazione &gt; Accesso e sicurezza</b> e aggiungi l'email del service account (qualsiasi livello tranne "Solo email").</li>
																<li>Carica qui il file JSON e scrivi l'ID cliente (10 cifre); l'ID dell'account manager solo se entri da lì.</li>
															</ol>
														</v-alert>
														<div class="mb-3">
															<v-file-input
																v-model="fileGoogleAds"
																label="File JSON del service account"
																accept=".json"
																show-size
																dense
																outlined
																hide-details
																background-color="white"
																@change="f => handleFileUpload(f, 'googleads')"
															></v-file-input>
															<a v-if="googleads.setting.apikey" :href="googleads.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														</div>
													</template>
													<!-- DataForSEO: idee per la parola chiave nell'Analisi SEO; la password non torna mai dal server -->
													<template v-if="s.key === 'dataforseo'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
														Nel pannello Analisi SEO di prodotti, categorie, marche, pagine e articoli compare <strong>Idee parole chiave</strong>: alternative alla parola chiave con volume di ricerca mensile, andamento, difficoltà e intento. Ogni nuova ricerca costa circa 1 centesimo sul saldo DataForSEO; le ricerche già fatte restano salvate per 30 giorni. Login e password sono quelli API di
														<a href="https://app.dataforseo.com/api-access" target="_blank" rel="noopener">app.dataforseo.com/api-access</a>, non quelli di accesso al sito.
														</v-alert>
														<div class="seo-small mb-2">
															Password API:
															<v-chip x-small label :color="dataforseo.setting.hasPassword ? 'success' : 'grey lighten-2'" class="ml-1">{{ dataforseo.setting.hasPassword ? 'Impostata' : 'Assente' }}</v-chip>
															<span v-if="dataforseo.setting.hasPassword" class="ml-1">lasciala vuota per non cambiarla</span>
														</div>
													</template>
													<!-- Google Trends: API in alpha, accesso su richiesta -->
													<template v-if="s.key === 'googletrends'">
														<v-alert outlined text dense type="info" class="text-body-2 mb-3">
															Mostra nella modifica prodotto come cambia negli ultimi 5 anni l'interesse su Google per la parola chiave principale (andamento, variazione annua, mesi di picco).
															<div class="mt-2">
																La <b>Google Trends API</b> è in alpha: l'accesso si ottiene su richiesta a Google. Finché non è attivo, il box nella scheda prodotto mostra un avviso.
															</div>
														</v-alert>
														<div class="mb-3">
															<v-file-input
																v-model="fileTrends"
																label="File JSON delle credenziali (quando l'accesso sarà attivo)"
																accept=".json"
																show-size
																dense
																outlined
																hide-details
																background-color="white"
																@change="f => handleFileUpload(f, 'googletrends')"
															></v-file-input>
															<a v-if="googletrends.setting.apikey" :href="googletrends.setting.apikey" target="_blank" class="seo-small">File JSON caricato</a>
														</div>
													</template>
													<!-- Facebook Marketplace: url dei feed da inserire nel catalogo -->
													<v-alert v-if="s.key === 'facebookmarketplace'" outlined text dense type="info" class="text-body-2 seo-url mb-3">
														Dopo aver cliccato su Salva inserire i seguenti url su https://www.facebook.com/products/catalogs
														<div v-for="feed in facebookMarketplaceFeedUrls" :key="feed.lang" class="mt-2">
															<b>{{ feed.label }}</b> {{ feed.url }}
														</div>
														<p class="mt-2 mb-0">
															Nella piattaforma https://business.facebook.com/commerce_manager bisogna inserire i cataloghi nelle varie lingue, creare lo shop e associare le lingue ai vari paesi.
														</p>
													</v-alert>
													<template v-slot:dopo>
														<esclusioni-feed
															v-if="s.feed"
															:modello="modello(s)"
															:categorie="categoryGoogleMerchant"
															:brands="brands"
															:listcategories="listcategories"
															:listitems-i-t="listitemsIT"
															:search-item-i-t.sync="searchItemIT"
														/>
													</template>

													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"
															><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn
														>
														<template v-if="s.key === 'googlemerchant'">
															<v-btn small outlined color="primary" @click="sendItem(2)"><v-icon left small>mdi-upload</v-icon>Carica prodotti</v-btn>
															<v-btn small outlined color="primary" @click="sendShipping(2)"><v-icon left small>mdi-truck-outline</v-icon>Carica spese di spedizione</v-btn>
															<v-btn small outlined color="error" @click="confermaElimina = true"><v-icon left small>mdi-delete-outline</v-icon>Elimina prodotti</v-btn>
															<v-spacer></v-spacer>
														</template>
														<v-spacer v-if="s.connessione && s.key !== 'googlemerchant'"></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog v-model="confermaElimina" max-width="420">
			<v-card>
				<v-card-title class="text-h6">Eliminare i prodotti da Google Merchant?</v-card-title>
				<v-card-text class="text-left">Tutti i prodotti caricati verranno rimossi dal catalogo di Google Merchant. Per rimetterli bisogna ricaricarli con "Carica prodotti".</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="confermaElimina = false">Annulla</v-btn>
					<v-btn
						color="error"
						text
						@click="
							confermaElimina = false;
							deleteItem();
						"
						>Elimina</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createSeoTourSteps, stopSeoTour } from './seo-tour';
import { uuid } from 'vue-uuid';
import { Category } from '@/utils/Category';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import EsclusioniFeed from './components/EsclusioniFeed.vue';

export default {
	name: 'Seo',
	setup() {
		return { tour: useTour(createSeoTourSteps(), { onStop: stopSeoTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			videtranslate: '5hTlSGD4_zk',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			file: null,
			fileSearchConsole: null,
			fileGoogleAds: null,
			fileTrends: null,
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'googletranslate' },
			headers: [
				{ text: '', sortable: false },
				{ text: 'Servizio', sortable: false },
				{ text: 'Status', sortable: false },
			],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,
			yoast: {
				active: '',
				setting: {},
				service: 'yoast',
				type: 'seo',
			},
			googletranslate: {
				active: '',
				setting: {
					type: '',
					project_id: '',
					private_key_id: '',
					private_key: '',
					client_email: '',
					client_id: '',
					auth_uri: '',
					token_uri: '',
					auth_provider_x509_cert_url: '',
					client_x509_cert_url: '',
					api_key: '',
				},
				service: 'googletranslate',
				type: 'seo',
			},
			categoryGoogleMerchant: [
				{
					id: '166',
					name: 'Abbigliamento e accessori',
					original: 'Abbigliamento e accessori',
				},
				{
					id: '436',
					name: 'Arredamento',
					original: 'Arredamento',
				},
				{
					id: '8',
					name: 'Arte e svago',
					original: 'Arte e svago',
				},
				{
					id: '632',
					name: 'Articoli di ferramenta',
					original: 'Articoli di ferramenta',
				},
				{
					id: '772',
					name: 'Articoli per adulti',
					original: 'Articoli per adulti',
				},
				{
					id: '1',
					name: 'Articoli per animali',
					original: 'Articoli per animali',
				},
				{
					id: '5605',
					name: 'Articoli religiosi e per cerimonie',
					original: 'Articoli religiosi e per cerimonie',
				},
				{
					id: '988',
					name: 'Articoli sportivi',
					original: 'Articoli sportivi',
				},
				{
					id: '5181',
					name: 'Bagagli e borse',
					original: 'Bagagli e borse',
				},
				{
					id: '537',
					name: 'Bebè e bimbi',
					original: 'Bebè e bimbi',
				},
				{
					id: '536',
					name: 'Casa e giardino',
					original: 'Casa e giardino',
				},
				{
					id: '412',
					name: 'Cibo, bevande e tabacco',
					original: 'Cibo, bevande e tabacco',
				},
				{
					id: '111',
					name: 'Commercio e industria',
					original: 'Commercio e industria',
				},
				{
					id: '222',
					name: 'Dispositivi elettronici',
					original: 'Dispositivi elettronici',
				},
				{
					id: '922',
					name: 'Forniture per ufficio',
					original: 'Forniture per ufficio',
				},
				{
					id: '141',
					name: 'Fotocamere/dispositivi ottici',
					original: 'Fotocamere/dispositivi ottici',
				},
				{
					id: '1239',
					name: 'Giochi e giocattoli',
					original: 'Giochi e giocattoli',
				},
				{
					id: '783',
					name: 'Media',
					original: 'Media',
				},
				{
					id: '469',
					name: 'Salute e bellezza',
					original: 'Salute e bellezza',
				},
				{
					id: '2092',
					name: 'Software',
					original: 'Software',
				},
				{
					id: '888',
					name: 'Veicoli e parti',
					original: 'Veicoli e parti',
				},
			],
			googlemerchant: {
				active: false,
				setting: {
					apikey: '',
					merchantId: '',
					category: {},
					config: {
						country: [],
						excluded: {
							brands: [],
							categories: [],
							items: [],
						},
						active: true,
						show: true,
					},
				},
				type: 'marketing',
				service: 'googlemerchant',
			},
			googlesearchconsole: {
				active: false,
				setting: {
					apikey: '',
					siteUrl: '',
				},
				type: 'seo',
				service: 'googlesearchconsole',
			},
			googletrends: {
				active: false,
				setting: {
					apikey: '',
					geo: '',
				},
				type: 'seo',
				service: 'googletrends',
			},
			googleads: {
				active: false,
				setting: {
					apikey: '',
					customerId: '',
					loginCustomerId: '',
					location: '',
				},
				type: 'seo',
				service: 'googleads',
			},
			// password cifrata sul server: dal server arriva vuota con hasPassword
			dataforseo: {
				active: false,
				setting: {
					login: '',
					password: '',
					location: '',
					hasPassword: false,
				},
				type: 'seo',
				service: 'dataforseo',
			},
			bingmerchant: {
				active: false,
				setting: {
					apikey: '',
					merchantId: '',
					category: {},
					config: {
						country: [],
						excluded: {
							brands: [],
							categories: [],
							items: [],
						},
					},
				},
				type: 'marketing',
				service: 'bingmerchant',
			},
			facebookmarketplace: {
				active: false,
				setting: {
					category: {},
					config: {
						country: [],
						excluded: {
							brands: [],
							categories: [],
							items: [],
						},
					},
				},
				type: 'marketing',
				service: 'facebookmarketplace',
			},
			affiliate: {
				active: false,
				setting: {
					invitation: true,
					month: 1,
					fee: 1,
					min: 0,
				},
				type: 'marketing',
				service: 'affiliate',
			},
			languages: [],
			brands: [],
			listcategories: [],
			// conferma di "Elimina prodotti" (Google Merchant)
			confermaElimina: false,
			listitemsIT: [],
			searchItemIT: '',
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	/**
	 * Initializes the component by preloading settings, fetching necessary services, and
	 * building category and brand lists. Additionally, prepares configurations for services
	 * like Yoast, Google Translate, and Google Merchant. Watches changes in certain configurations
	 * to fetch relevant items dynamically.
	 *
	 * @return {Promise<void>} A promise that resolves when the initialization process is completed.
	 */
	async created() {
		/**
		 * configs: [
		 *   lang:"it",
		 *   country:["IT", "FR"],
		 *   excluded:{
		 *     brands:[],
		 *     categories:[],
		 *     items:[]
		 *   }
		 *
		 * ]
		 */
		this.setPreload(true);
		try {
			let promises = [];
			promises.push(this.fetchSettings());
			promises.push(this.fetchService(['yoast', 'googletranslate', 'googlemerchant', 'bingmerchant', 'facebookmarketplace', 'affiliate', 'googlesearchconsole', 'googletrends', 'dataforseo', 'googleads', 'storage']));
			await Promise.all(promises);

			// la lingua di default si cerca fra tutte: sui profili vecchi `show` manca e il filtro su show non trovava nulla
			const languages = this.getSettings.languages || [];
			const linguaDefault = languages.find(el => el.default) || languages.find(el => el.is_active) || languages[0];
			this.langDefault = linguaDefault ? linguaDefault.lang : 'it';
			this.listBrand = await this.fetchLists();
			const Abrands = this.listBrand.data.map(res => {
				const trans = _.find(res.trans, { lang: this.langDefault });
				return { _id: res._id, name: trans ? trans.name : '' };
			});
			this.brands = _.orderBy(Abrands, ['name'], ['asc']);

			const category = new Category(this.getSettings.categories, this.langDefault);
			await category.build();
			await category.refactorCategory();
			await category.createPath();
			await category.dynamicSort();
			this.listcategories = await category.getTree;
		} catch (e) {
			console.error('[setting/seo] caricamento non completato', e);
		} finally {
			// mai lasciare la pagina bloccata dal caricamento
			this.setPreload(false);
		}

		let yoast = _.find(this.getServices, set => {
			return set.service === 'yoast';
		});
		if (yoast) {
			this.yoast = yoast;
		}
		let googletranslate = _.find(this.getServices, set => {
			return set.service === 'googletranslate';
		});
		if (googletranslate) {
			this.googletranslate = googletranslate;
		}
		let googlemerchant = _.find(this.getServices, set => {
			return set.service === 'googlemerchant';
		});
		if (googlemerchant) {
			this.listitemsIT = googlemerchant.setting.config.excluded.items;
			this.googlemerchant = googlemerchant;
		}
		let bingmerchant = _.find(this.getServices, set => {
			return set.service === 'bingmerchant';
		});
		if (bingmerchant) {
			this.listitemsIT = bingmerchant.setting.config.excluded.items;
			this.bingmerchant = bingmerchant;
		}
		let facebookmarketplace = _.find(this.getServices, set => {
			return set.service === 'facebookmarketplace';
		});
		if (facebookmarketplace) {
			this.listitemsIT = facebookmarketplace.setting.config.excluded.items;
			this.facebookmarketplace = facebookmarketplace;
		}
		const googlesearchconsole = _.find(this.getServices, { service: 'googlesearchconsole' });
		if (googlesearchconsole) {
			this.googlesearchconsole = { ...googlesearchconsole, setting: { apikey: '', siteUrl: '', ...(googlesearchconsole.setting || {}) } };
		}
		const googletrends = _.find(this.getServices, { service: 'googletrends' });
		if (googletrends) {
			this.googletrends = { ...googletrends, setting: { apikey: '', geo: '', ...(googletrends.setting || {}) } };
		}
		const googleads = _.find(this.getServices, { service: 'googleads' });
		if (googleads) {
			this.googleads = {
				...googleads,
				setting: { apikey: '', customerId: '', loginCustomerId: '', location: '', ...(googleads.setting || {}) },
			};
		}
		const dataforseo = _.find(this.getServices, { service: 'dataforseo' });
		if (dataforseo) {
			this.dataforseo = { ...dataforseo, setting: { login: '', location: '', hasPassword: false, ...(dataforseo.setting || {}), password: '' } };
		}
		let affiliate = _.find(this.getServices, set => {
			return set.service === 'affiliate';
		});
		if (affiliate) {
			this.affiliate = affiliate;
		}
	},
	watch: {
		searchItemIT: _.debounce(function (val) {
			if (val == null || val === '' || val.length < 3) return;

			this.isLoading = true;
			var setting = {
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
				filters: '',
				search: val,
			};
			///console.log("setting",setting)
			let items = this.fetchProducts(setting);
			items
				.then(result => {
					this.listitemsIT = [...this.googlemerchant.setting.config.excluded.items, ...result];
				})

				.finally(() => (this.isLoading = false));
		}, 200),
	},
	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		EsclusioniFeed,
		MarketplaceConnectionCheck,
	},
	computed: {
		descrizioneAnalisi() {
			return 'Punteggio e consigli nelle schede di prodotti, categorie e marche. Spenta, il pannello non compare.';
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getPermissions: 'profile/getPermissions',

			getServices: 'services/getServices',
		}),
		// servizi con configurazione (Yoast ha solo l'interruttore): indice = argomento di saveSetting/extension
		servizi() {
			const tutti = [
				{
					indice: 1,
					key: 'googletranslate',
					connessione: 'googletranslate',
					nome: 'Google translate',
					logo: require('@/assets/images/Google_Translate_logo.svg'),
					campi: [
						{ key: 'project_id', label: 'Project Id' },
						{ key: 'api_key', label: 'Api Key', tipo: 'password' },
					],
				},
				{
					indice: 2,
					key: 'googlemerchant',
					connessione: 'googlemerchant',
					nome: 'Google Merchant Center',
					logo: require('@/assets/images/google-merchant-center.svg'),
					permesso: 'marketing.googlemerchant',
					feed: true,
					campi: [{ key: 'merchantId', label: 'Merchant Id' }],
				},
				{
					indice: 3,
					key: 'bingmerchant',
					nome: 'Bing Merchant Center',
					logo: require('@/assets/images/bing-merchant-center.svg'),
					permesso: 'marketing.bingmerchant',
					feed: true,
					campi: [
						{ key: 'apikey', label: 'Api Key', tipo: 'password' },
						{ key: 'merchantId', label: 'Merchant Id' },
					],
				},
				{
					indice: 4,
					key: 'facebookmarketplace',
					nome: 'Facebook Marketplace',
					logo: require('@/assets/images/seo/facebookMarketplace.svg'),
					feed: true,
					campi: [],
				},
				{
					indice: 6,
					key: 'googlesearchconsole',
					connessione: 'googlesearchconsole',
					nome: 'Google Search Console',
					logo: require('@/assets/images/seo/google-search-console.svg'),
					campi: [{ key: 'siteUrl', label: 'Proprietà Search Console (es. sc-domain:tuosito.it)', pieno: true }],
				},
				{
					indice: 7,
					key: 'googletrends',
					connessione: 'googletrends',
					nome: 'Google Trends',
					logo: require('@/assets/images/seo/google-trends.png'),
					campi: [{ key: 'geo', label: 'Paese (es. IT; vuoto = quello della lingua della scheda)' }],
				},
				{
					indice: 8,
					key: 'dataforseo',
					connessione: 'dataforseo',
					nome: 'DataForSEO',
					logo: require('@/assets/images/seo/dataforseo.png'),
					campi: [
						{ key: 'login', label: 'API login' },
						{ key: 'password', label: 'API password', tipo: 'password' },
						{ key: 'location', label: 'Paese (es. IT; vuoto = quello della lingua della scheda)', pieno: true },
					],
				},
				{
					indice: 9,
					key: 'googleads',
					connessione: 'googleads',
					nome: 'Google Ads - Keyword Planner',
					logo: require('@/assets/images/seo/google-ads.png'),
					campi: [
						{ key: 'customerId', label: 'ID cliente Google Ads (10 cifre)' },
						{ key: 'loginCustomerId', label: 'ID account manager (facoltativo)' },
						{ key: 'location', label: 'Paese (es. IT; vuoto = quello della lingua della scheda)' },
					],
				},
				{
					indice: 5,
					key: 'affiliate',
					nome: 'Affiliazione',
					logo: require('@/assets/images/marketing/affiliate.png'),
					titoloSwitch: 'Fatturazione',
					campi: [
						{ key: 'min', label: 'Minimo fatturabile' },
						{ key: 'month', label: 'Mesi precedenti' },
						{ key: 'fee', label: 'Commissione di default' },
						{ key: 'invitation', label: 'Invia una mail con invito a fatturare', tipo: 'switch' },
					],
				},
			];
			return tutti.filter(s => !s.permesso || this.checkPermissions(s.permesso));
		},
		// dove il backend pubblica i feed: lo storage proprio del cliente (Impostazioni > Storage) se attivo,
		// altrimenti il CloudFront di AzSeller come sempre
		feedBaseUrl() {
			const storage = _.find(this.getServices, { service: 'storage' });
			const st = storage && storage.active && storage.setting;
			if (st && st.provider === 'aws' && st.bucket) {
				if (st.cdnUrl) return String(st.cdnUrl).replace(/\/+$/, '');
				return st.region ? `https://${st.bucket}.s3.${st.region}.amazonaws.com` : `https://${st.bucket}.s3.amazonaws.com`;
			}
			return 'https://dtjucktru7npk.cloudfront.net';
		},
		facebookMarketplaceFeedUrls() {
			const languages = (this.getSettings.languages || []).filter(language => language.is_active && language.show);
			return languages.map(language => ({
				lang: language.lang,
				label: language.name || language.lang.toUpperCase(),
				url: `${this.feedBaseUrl}/facebook-marketplace/${this.getId}-${language.lang}.csv`,
			}));
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
			fetchLists: 'brands/fetchLists',
			fetchProducts: 'items/asyncSearchData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		/**
		 * Handles the file upload process by sending the file to a given endpoint and updating relevant settings.
		 *
		 * @param {File} file The file object to be uploaded. It should include a name property.
		 * @param {string} servizio servizio in data() che riceve l'url del file (Merchant, Search Console o Trends)
		 * @return {Promise<void>} Resolves when the file upload process is completed.
		 */
		async handleFileUpload(file, servizio = 'googlemerchant') {
			if (file && file.name) {
				const formData = new FormData();
				formData.append('file', file, file.name);
				formData.append('uuid', uuid.v4());

				const response = await axios.post(`${this.getUrl}multimedias/uploadfile`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data', // Imposta il tipo di contenuto
						Authorization: `Bearer ${this.getToken}`,
					},
				});

				this[servizio].setting.apikey = response.data.url;
				this.$forceUpdate();
				//payload.value['sitemaps'].push(image);
			}
			/*if (this.amazonpay.setting?.pem) {
        console.log('File caricato:', this.amazonpay.setting.pem);
      }*/
		},
		sendItem() {
			let url = 'googlemerchant/import';
			axios.post(
				`${this.getUrl}${url}`,
				{},
				{
					headers: { Authorization: `Bearer ${this.getToken}` },
				},
			);

			this.snackbar.color = 'success';
			this.snackbar.text = 'Operazione effettuata con  successo i prodotti sono stati inseriti nella lista di Google Merchant';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		deleteItem() {
			let url = 'googlemerchant/delete';
			axios.post(
				`${this.getUrl}${url}`,
				{},
				{
					headers: { Authorization: `Bearer ${this.getToken}` },
				},
			);

			this.snackbar.color = 'success';
			this.snackbar.text = 'Operazione effettuata con  successo i prodotti saranno eliminati a breve su Google Merchant';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		sendShipping() {
			this.setPreload(true);
			let url = 'googlemerchant/shipping';
			axios
				.post(
					`${this.getUrl}${url}`,
					{},
					{
						headers: { Authorization: `Bearer ${this.getToken}` },
					},
				)
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = spenta
						? `Le idee per la parola chiave ora usano ${item === 9 ? 'Google Keyword Planner' : 'DataForSEO'}: ${spenta === 'googleads' ? 'Google Ads' : 'DataForSEO'} è stato spento.`
						: 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async generateFacebookMarketplaceFeed() {
			return axios.post(
				`${this.getUrl}facebookmarketplace/generate`,
				{},
				{
					headers: { Authorization: `Bearer ${this.getToken}` },
				},
			);
		},
		async saveSetting(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.yoast;
					this.setPreload(true);
					break;
				case 1:
					payload = this.googletranslate;
					this.setPreload(true);
					break;
				case 2:
					payload = this.googlemerchant;
					this.setPreload(true);
					break;
				case 3:
					payload = this.bingmerchant;
					this.setPreload(true);
					break;
				case 4:
					payload = this.facebookmarketplace;
					this.setPreload(true);
					break;
				case 5:
					payload = this.affiliate;
					this.setPreload(true);
					break;
				case 6:
					payload = this.googlesearchconsole;
					this.setPreload(true);
					break;
				case 7:
					payload = this.googletrends;
					this.setPreload(true);
					break;
				case 8:
					payload = this.dataforseo;
					this.setPreload(true);
					break;
				case 9:
					payload = this.googleads;
					this.setPreload(true);
					break;
			}
			// idee per la parola chiave: DataForSEO e Google Ads sono alternativi, accendendone uno l'altro si spegne
			const altraFonte = { 8: 'googleads', 9: 'dataforseo' }[item];
			const spenta = altraFonte && payload.active && this[altraFonte].active ? altraFonte : null;
			if (spenta) {
				this[spenta].active = false;
				try {
					const { data } = await axios.post(`${this.getUrl}services/update`, this[spenta], { headers: { Authorization: `Bearer ${this.getToken}` } });
					this.setService(data.data);
				} catch (e) {
					this[spenta].active = true;
				}
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(async ({ data }) => {
					if (item === 4) {
						await this.generateFacebookMarketplaceFeed();
					}
					// la password appena salvata non resta nel form: dal server torna solo hasPassword
					if (item === 8 && data.data) {
						this.dataforseo = { ...this.dataforseo, setting: { ...this.dataforseo.setting, ...(data.data.setting || {}), password: '' } };
					}

					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del servizio: created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
		checkPermissions(module) {
			// i permessi arrivano dopo il primo render: finche' mancano il servizio resta nascosto
			return !!(this.getPermissions && this.getPermissions.modules && this.getPermissions.modules.includes(module));
		},
	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* video Google Translate in cima al riquadro */
.seo-video {
	max-width: 560px;
	margin-bottom: 16px;
}
.seo-video-caption {
	display: flex;
	align-items: center;
	font-size: 13px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.seo-small {
	font-size: 13px;
}
/* la tabella e' "cellanowrap": nel riquadro aperto di un servizio testi e avvisi vanno a capo */
.as-expanded td {
	white-space: normal;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.seo-cards,
.seo-cards tr {
	display: block;
	width: 100%;
}
.seo-cards tr,
.seo-cards tr:hover {
	background: transparent !important;
}
.seo-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.seo-cards tr:first-child td {
	padding-top: 12px !important;
}
.seo-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.seo-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* url dei feed lunghi: vanno a capo dentro la card */
.seo-url {
	overflow-wrap: anywhere;
}
</style>
